import { Editor } from '@tiptap/core';
import { useCurrentEditor } from '@tiptap/react';
import { useCallback, useEffect, useState } from 'react';

import { LanguageToolStorage } from '.';

export function useStorage<T>(selector: (storage: LanguageToolStorage) => T): T {
  const { editor } = useCurrentEditor();

  if (!editor) throw new Error('Editor not found');

  const [state, setState] = useState(() =>
    selector(editor.storage.languagetool as LanguageToolStorage),
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoSelector = useCallback(selector, []);

  useEffect(() => {
    const updateMatch = (editor: Editor) => {
      const storage: LanguageToolStorage = editor.storage.languagetool;

      setState(memoSelector(storage));
    };

    editor?.on('transaction', ({ editor }) => updateMatch(editor));

    return () => {
      editor?.off('transaction', ({ editor }) => updateMatch(editor));
    };
  }, [editor, memoSelector]);

  return state;
}
